import { useState, useEffect } from "react"
import PrefrenceCard from "./prefrences/PrefrenceCard"
import SuccessDialog from "./common/SuccessDialog"
import ConfirmDialog from "./common/ConfirmDialog"
import PrefrenceModal from "./prefrences/PreferenceModal"
import { savePrefrences, } from "../api/PrefrenceAPI"
import { Snackbar, Alert } from "@mui/material"




const Preferences = ({ preferencesData: initialData, onSaveSuccess }) => {
  const [prefrencesData, setPrefrencesData] = useState(initialData || [])
  const [showEditModal, setShowEditModal] = useState(false)
  const [currentEditData, setCurrentEditData] = useState(null)

  const [confirmDialog, setConfirmDialog] = useState({ open: false, data: null })
  const [showSuccess, setShowSuccess] = useState(false)

  const [snackbar, setSnackbar] = useState({ open: false, message: "" })
  const user_id = localStorage.getItem("userId")
  useEffect(() => {
    setPrefrencesData(initialData || [])
  }, [initialData])


  /** ------------------------
   * Edit Prefrence (Update)
   * ----------------------- */
  const handleEditSave = async (formData, id) => {
    setConfirmDialog({ open: true, data: { mode: "edit", formData, id } })
  }

  /** ------------------------
   * Confirm Save -> Call API
   * ----------------------- */
  const handleConfirm = async () => {
    const { formData, id } = confirmDialog.data || {}
    try {
      let payload = {
        ...formData,
        user_id: user_id,
      }


      const res = await savePrefrences(payload)

      if (res?.success) {
        setConfirmDialog({ open: false, data: null })
        setShowEditModal(false)
        setShowSuccess(true)
      } else {
        setSnackbar({
          open: true,
          message: res?.message || "Failed to save test score",
        })
      }
    } catch (err) {
      console.error("Error saving test score:", err)
      setSnackbar({ open: true, message: "Something went wrong. Try again." })
    }
  }

  /** ------------------------
   * Open Edit
   * ----------------------- */
  const handleCardEdit = (test) => {
    setCurrentEditData(test)
    setShowEditModal(true)
  }

  return (
    <div className="relative">
      {prefrencesData.map((prefrence, index) => (
        <PrefrenceCard
          key={index}
          prefrence={prefrence}
          onEdit={() => handleCardEdit(prefrence)}
        />
      ))}




      {/* Edit Modal */}
      <PrefrenceModal
        open={showEditModal}
        onClose={() => {
          setShowEditModal(false)
          setCurrentEditData(null)
        }}
        onSave={handleEditSave}   // calls when "Save" clicked inside modal
        editData={currentEditData} // this pre-fills the modal
      />


      {/* Confirm Dialog */}
      <ConfirmDialog
        open={confirmDialog.open}
        title="Confirm Save"
        message="Are you sure you want to save the Prefrence Details?"
        onCancel={() => setConfirmDialog({ open: false, data: null })}
        onConfirm={handleConfirm}
      />

      {/* Success Dialog */}
      <SuccessDialog
        open={showSuccess}
        message="Your Prefrence Details has been saved successfully."
        onClose={() => setShowSuccess(false)}
        onSuccess={() => {
          setShowSuccess(false)
          if (onSaveSuccess) onSaveSuccess()
        }}
      />

      {/* Snackbar for messages */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

    </div>
  )
}

export default Preferences